interface headerInterface {
  "X-Compatibility-Date": "2025-08-26";
}

export const defaultHeaders: headerInterface = {
  "X-Compatibility-Date": "2025-08-26",
};
